import { type FunctionComponent, lazy, type ReactNode, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCurateOutletStateProvider = lazy(() => {
  return new Promise<{ default: FunctionComponent<{ children: ReactNode }> }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: (props) => <lib.default.StateProvider {...props} />,
        });
      })
      .catch(reject);
  });
});

export const LazyCurateOutletStateProvider = (props: { children: ReactNode }) => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCurateOutletStateProvider {...props} />
    </Suspense>
  );
};
